import React, { ReactNode } from "react";
import { Page } from "../activities/AppPage";
import { Loading } from "../Loading";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { Sidebar } from "./Sidebar";

interface Props {
  caregiver: Loading | AppCaregiver;
  caregiverRating: ReactNode;
  onRequestNavigate: (page: Page) => void;
}

const SidebarFactory = ({ caregiver, onRequestNavigate, caregiverRating }: Props) => {
  const handleClickEditProfile = React.useCallback(() => {
    onRequestNavigate({ type: "Profile" });
  }, [onRequestNavigate]);

  const handleClickSettings = React.useCallback(() => {
    onRequestNavigate({ type: "Settings" });
  }, [onRequestNavigate]);

  const handleClickAgencies = React.useCallback(() => {
    onRequestNavigate({
      type: "MyAgencies",
      addAgency: false,
      resetOnFinish: false,
      popOnNotWorkingWithAgency: false,
    });
  }, [onRequestNavigate]);

  const handleClickMedFlytChallenge = React.useCallback(() => {
    onRequestNavigate({ type: "MedFlytChallenge" });
  }, [onRequestNavigate]);

  const handleClickHelp = React.useCallback(() => {
    onRequestNavigate({ type: "SettingsHelp" });
  }, [onRequestNavigate]);

  const handleClickCaseSettings = React.useCallback(() => {
    onRequestNavigate({ type: "CaseSettings" });
  }, [onRequestNavigate]);

  const handleClickEditRequests = React.useCallback(() => {
    onRequestNavigate({ type: "EditRequests" });
  }, [onRequestNavigate]);

  const handleClickUploadDocFiles = React.useCallback(() => {
    onRequestNavigate({ type: "MedflytPassport" });
  }, [onRequestNavigate]);

  const handleClickMyMedfltCompliance = React.useCallback(() => {
    onRequestNavigate({ type: "MyMedflytCompliance" });
  }, [onRequestNavigate]);

  const handleClickInformationCenter = React.useCallback(() => {
    onRequestNavigate({ type: "InformationCenter", caregiver: caregiver });
  }, [caregiver, onRequestNavigate]);

  const handleClickCarebackPoints = React.useCallback(() => {
    onRequestNavigate({ type: "CarebackPoints", caregiver: caregiver });
  }, [caregiver, onRequestNavigate]);

  const handleClickPaystubs = React.useCallback(() => {
    onRequestNavigate({ type: "CaregiverPaystubList", caregiver: caregiver });
  }, [caregiver, onRequestNavigate]);

  return (
    <Sidebar
      caregiver={caregiver}
      caregiverRating={caregiverRating}
      onProfileEditClick={handleClickEditProfile}
      onSettingsClick={handleClickSettings}
      onAgenciesClick={handleClickAgencies}
      onMedFlytChallengeClick={handleClickMedFlytChallenge}
      onHelpClick={handleClickHelp}
      onCaseSettingsClick={handleClickCaseSettings}
      onEditRequestsClick={handleClickEditRequests}
      onUploadDocFilesClick={handleClickUploadDocFiles}
      onClickMyMedfltCompliance={handleClickMyMedfltCompliance}
      onClickInformationCenter={handleClickInformationCenter}
      onClickCarebackPoints={handleClickCarebackPoints}
      onClickPaystubs={handleClickPaystubs}
    />
  );
};

export default SidebarFactory;
